import React from "react";

export default function Footer() {
  return (
    <footer className="w-full bg-gradient-to-b from-[#4BA3C3] to-[#2E7FA3] text-white py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row justify-center items-center gap-4">
        <p className="text-[#B3D9E8] text-xs text-center sm:text-left">
          © 2025 SkillsMD | All rights reserved
        </p>
      </div>
    </footer>
  );
}
